import React from "react";
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    logoContainer: {
        backgroundColor: theme.palette.iisightDarkBrandBackground,
    },
}));
export const LogoContainer = () => {
    const { cx, classes } = useStyles();
    return React.createElement("div", { className: cx('pageLogoContainer', classes.logoContainer) });
};
